import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

export default function EmptyModal(props) {
  const { childComponent, open, setOpen, fullHeight, wide } = props;

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="hide-for-print relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() =>
          setOpen({
            childComponent: null,
            open: false,
          })
        }
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#0F172A] bg-opacity-35 backdrop-blur-[1px] transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto z-10">
          <div
            className={`flex ${fullHeight ? "mt-[50%]" : "mt-0"} sm:mt-0 sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 z-10`}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`qatrace-screen relative transform overflow-hidden rounded-[18px] border border-[#E2E8F0] bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full ${wide ? "sm:max-w-2xl" : "sm:max-w-lg"} sm:p-6 z-10`}
              >
                {childComponent}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
